import { render, staticRenderFns } from "./DentalAppointmentPendingForm.vue?vue&type=template&id=2e5e4d87&"
import script from "./DentalAppointmentPendingForm.vue?vue&type=script&lang=js&"
export * from "./DentalAppointmentPendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports